var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 43.675,
    rx: 8,
    fill: "#0F1CB7",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 30.675C21.7667 30.675 21.529 30.6333 21.287 30.55C21.045 30.4667 20.8327 30.3333 20.65 30.15L18.925 28.575C17.1583 26.9583 15.5623 25.354 14.137 23.762C12.7117 22.17 11.9993 20.416 12 18.5C12 16.9333 12.525 15.625 13.575 14.575C14.625 13.525 15.9333 13 17.5 13C18.3833 13 19.2167 13.1873 20 13.562C20.7833 13.9367 21.45 14.4493 22 15.1C22.55 14.45 23.2167 13.9373 24 13.562C24.7833 13.1867 25.6167 12.9993 26.5 13C28.0667 13 29.375 13.525 30.425 14.575C31.475 15.625 32 16.9333 32 18.5C32 20.4167 31.2917 22.175 29.875 23.775C28.4583 25.375 26.85 26.9833 25.05 28.6L23.35 30.15C23.1667 30.3333 22.9543 30.4667 22.713 30.55C22.4717 30.6333 22.234 30.675 22 30.675Z",
    fill: "#0F1CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcon);
export default __webpack_public_path__ + "static/media/FavouriteIcon.241af49701415843e93df6b7912446a1.svg";
export { ForwardRef as ReactComponent };